/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Start_Time_Only_LabelInputs */

const en_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Time Only`)
};

const fr_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de debut seulement`)
};

const de_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Startzeit`)
};

const it_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo ora di inizio`)
};

const ru_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только время начала`)
};

const es_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo hora de inicio`)
};

const zh_cn2_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限开始时间`)
};

const ja_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間のみ`)
};

const hi_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल प्रारंभ समय`)
};

const pt_pt2_timing_sync_start_time_only_label = /** @type {(inputs: Timing_Sync_Start_Time_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente o horário de início`)
};

/**
* | output |
* | --- |
* | "Start Time Only" |
*
* @param {Timing_Sync_Start_Time_Only_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_start_time_only_label = /** @type {((inputs?: Timing_Sync_Start_Time_Only_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Start_Time_Only_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_start_time_only_label(inputs)
	if (locale === "de") return de_timing_sync_start_time_only_label(inputs)
	if (locale === "it") return it_timing_sync_start_time_only_label(inputs)
	if (locale === "ru") return ru_timing_sync_start_time_only_label(inputs)
	if (locale === "es") return es_timing_sync_start_time_only_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_start_time_only_label(inputs)
	if (locale === "ja") return ja_timing_sync_start_time_only_label(inputs)
	if (locale === "hi") return hi_timing_sync_start_time_only_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_start_time_only_label(inputs)
	return en_timing_sync_start_time_only_label(inputs)
});